"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = void 0;
exports.exportAttrs = exportAttrs;
exports.exportVNodeToString = exportVNodeToString;
var escape_xml_1 = require("./escape.xml");
var index_1 = require("./index");
exports.DEFAULT_OPTIONS = {
    lowerCaseTagName: false,
    indent: '  ',
    ignoreKeys: [],
    keyMap: {}
};
var convertStyle = function (styleAttrs) {
    if (typeof styleAttrs === 'string') {
        return styleAttrs;
    }
    return Object.keys(styleAttrs)
        .map(function (tag) {
        var value = styleAttrs[tag];
        if (typeof value === 'number') {
            value = value + 'px';
        }
        return "".concat(tag, ": ").concat(value);
    })
        .join(';');
};
function exportAttrs(attrs, options) {
    var output = [];
    Object.keys(attrs).forEach(function (key) {
        if (options.ignoreKeys.indexOf(key) > -1) {
            return;
        }
        var value = attrs[key];
        if (value == null || value === '') {
            return;
        }
        if (key === 'style') {
            value = convertStyle(value);
        }
        if (options.keyMap[key]) {
            key = options.keyMap[key];
        }
        var type = typeof value;
        if (type === 'function' || type === 'object') {
            throw Error('Unknown value "' + key + '":"' + value + '"');
        }
        if (typeof value === 'string') {
            value = (0, escape_xml_1.escapeXML)(value);
        }
        output.push("".concat(key, "=\"").concat(value, "\""));
    });
    return output.join(' ');
}
var optionKeys = Object.keys(exports.DEFAULT_OPTIONS);
function mergeDefaultOptions(options) {
    var output = {};
    if (options == null) {
        return exports.DEFAULT_OPTIONS;
    }
    optionKeys.forEach(function (key) {
        var val = options[key];
        if (val !== undefined) {
            output[key] = val;
        }
        else {
            output[key] = exports.DEFAULT_OPTIONS[key];
        }
    });
    return output;
}
function renderNode(node, options, indentString) {
    if (node == null) {
        return '';
    }
    var attrs = '';
    if (node.tag == null || node.tag === '') {
        throw new Error('Invalid VNode: ' + node);
    }
    var tag = node.tag;
    if (options.lowerCaseTagName) {
        tag = tag.toLowerCase();
    }
    if (node.attrs != null) {
        attrs = exportAttrs(node.attrs, options);
        if (attrs.length > 0) {
            attrs = ' ' + attrs;
        }
    }
    var indent = '';
    if (options.indent && indentString.length > 0) {
        indent = '\n' + indentString;
    }
    // Handle children
    var children = '';
    if (node.children && Array.isArray(node.children)) {
        children = node.children.map(function (child) { return exportVNode(child, options, indentString + options.indent); }).join('');
    }
    var shouldLineBreak = options.indent && indentString.length === 0 && children.length > 0;
    return [
        "<".concat(tag).concat(attrs, ">"),
        exportText(node.text),
        children,
        children.length > 0 ? indent : '',
        shouldLineBreak ? '\n' : '',
        "</".concat(tag, ">")
    ].join('');
}
function exportVNode(node, options, indentString) {
    if (node == null) {
        return '';
    }
    var indent = '';
    if (options.indent && indentString.length > 0) {
        indent = '\n' + indentString;
    }
    switch (node.tag) {
        case index_1.TRUSTED_TEXT_TAG:
            return indent + (node.text == null ? node.children : node.text);
        case index_1.TEXT_TAG:
            return indent + (0, escape_xml_1.escapeXML)(node.text == null ? node.children : node.text);
        case index_1.FRAGMENT_TAG:
            return node.children.map(function (child) { return exportVNode(child, options, indentString); }).join('');
        default:
            return indent + renderNode(node, options, indentString);
    }
}
function exportText(text) {
    return text != null ? (0, escape_xml_1.escapeXML)(text) : '';
}
function exportVNodeToString(node, options) {
    var currentOptions = mergeDefaultOptions(options);
    return exportVNode(node, currentOptions, '');
}
//# sourceMappingURL=export.string.js.map